import { Dict, is } from '@easeltv/utilities';

/**
 * flattenObject
 *
 * Flattens nested objects and arrays into the top level of the object
 *
 * @param input - Object wanting to be flattened
 * @param baseKey - A key the object properties should be scoped with
 * @returns
 */
export const flattenObject = (
    input: Dict<string, unknown>,
    baseKey?: string,
): Dict<string, unknown> =>
    Object.entries(input).reduce<Dict<string, unknown>>((sum, [key, value]) => {
        const newKey = baseKey ? `${baseKey}_${key}` : key;

        if (Array.isArray(value)) return { ...sum, [newKey]: value.join(', ') };

        if (is.object(value)) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            return { ...sum, ...flattenObject(value, newKey) };
        }

        return { ...sum, [newKey]: value };
    }, {});
